import { Tray } from "@phosphor-icons/react";
import { forwardRef } from "react";
import { cn } from "@/lib/cn";
import type { EmptyStateProps } from "./EmptyState.types";

const variantClassName = {
  default: "bfrs-min-h-56 bfrs-rounded-lg bfrs-border bfrs-border-dashed bfrs-border-border bfrs-bg-surface-muted bfrs-px-6 bfrs-py-10",
  compact: "bfrs-rounded-lg bfrs-border bfrs-border-dashed bfrs-border-border bfrs-bg-surface-muted bfrs-px-4 bfrs-py-5",
  "full-page": "bfrs-min-h-[320px] bfrs-px-6 bfrs-py-12",
  table: "bfrs-min-h-44 bfrs-px-6 bfrs-py-8"
} as const;

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, icon, illustration, title, description, primaryAction, secondaryAction, action, variant = "default", ...props }, ref) => (
    <div ref={ref} className={cn("bfrs-flex bfrs-flex-col bfrs-items-center bfrs-justify-center bfrs-text-center", variantClassName[variant], className)} {...props}>
      {illustration ?? (
        <div className={cn("bfrs-mb-4 bfrs-flex bfrs-items-center bfrs-justify-center bfrs-rounded-pill bfrs-bg-primary-soft bfrs-text-primary", variant === "compact" ? "bfrs-size-10" : "bfrs-size-12")}>
          {icon ?? <Tray size={variant === "compact" ? 20 : 24} weight="duotone" />}
        </div>
      )}
      <h3 className={cn("bfrs-font-semibold bfrs-text-text-primary", variant === "compact" ? "bfrs-text-sm" : "bfrs-text-base")}>{title}</h3>
      {description && <p className="bfrs-mt-2 bfrs-max-w-md bfrs-text-sm bfrs-leading-6 bfrs-text-text-muted">{description}</p>}
      {(primaryAction || secondaryAction || action) && (
        <div className="bfrs-mt-5 bfrs-flex bfrs-flex-wrap bfrs-items-center bfrs-justify-center bfrs-gap-2">
          {action}
          {secondaryAction}
          {primaryAction}
        </div>
      )}
    </div>
  )
);

EmptyState.displayName = "EmptyState";
